import React, { useState } from "react";
import {
    Button,
    Form,
    Grid,
    GridColumn,
    Header,
    Segment,
    Image,
} from "semantic-ui-react";
import logo from "../../assets/img/logoblancovertical.png";
import { useAuth } from "../../hooks/AuthProvider";
import { toast } from "react-toastify";

const Login = () => {

    const auth = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async (e: any) => {
        e.preventDefault();
        try {
            await auth.login(username, password);
        } catch (error: any) {
            toast.error(error.message);
        }
    };

    return (
        <Grid
            textAlign="center"
            style={{ height: "102vh", backgroundColor: "#000" }}
            verticalAlign="middle"
        >
            <GridColumn style={{ maxWidth: 450 }}>
                <Image src={logo} size="medium" centered />
                <Form error inverted size="large" onSubmit={handleLogin}>
                    <Segment style={{ marginTop: 30 }} inverted>
                        <Header as="h2" textAlign="center">
                            Iniciar sesion
                        </Header>

                        <Form.Input
                            fluid
                            icon="user"
                            iconPosition="left"
                            placeholder="Usuario"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />

                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Contraseña"
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        <Button inverted fluid size="large" type="submit">
                            Entrar
                        </Button>
                    </Segment>
                </Form>
            </GridColumn>
        </Grid>
    );
};

export default Login;
